module.exports = __webpack_public_path__ + "static/fonts/WebComponentsIcons.595e8d5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/glyphs/WebComponentsIcons.ttf?gedxeo
// module id = 1630
// module chunks = 28